import { render, staticRenderFns } from "./myFood.vue?vue&type=template&id=08ed9afe&scoped=true"
import script from "./myFood.vue?vue&type=script&lang=js"
export * from "./myFood.vue?vue&type=script&lang=js"
import style0 from "./myFood.vue?vue&type=style&index=0&id=08ed9afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ed9afe",
  null
  
)

export default component.exports